
import { Options, Vue } from 'vue-class-component'
import moment from 'moment'
import COVERAPP from '@/utils/COVERAPP'
import Config from '@/utils/config'

@Options({
  data() {
    return {
      list: [],
    }
  },
  props: ['data'],
  methods: {
    link(info) {
      if (COVERAPP.Attribute.isApp()) {
        return `${Config.APP_SCHEME_URL}/news?id=${info.news_id}&flag=${info.flag}`
      } else {
        if (info.flag === 1) {
          return 'https://m.thecover.cn/news_details.html?id=' + info.news_id
        }

        if (info.flag === 4) {
          return 'https://m.thecover.cn/video_details.html?id=' + info.news_id
        }
      }
    },
    fmTime(t) {
      return moment(t).format('MM月DD日 HH:ss');
    },
  },
})
export default class Timeline extends Vue {}
